import convert from "convert-units";
import round from "lodash/round";
import React from "react";

const {
  PARAMETER_OPTIONS: {
    REPS,
    RPE,
    RPEAMRAP,
    TIME,
    DISTANCE,
    LOAD,
    REST,
    VELOCITY,
    FREEFORM,
  },
} = require("../../constants");

import { RillContext } from "../../rill/RillReact/share/base";
import RpeInput from "./RpeInput";

class TextAreaComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      class: "row1",
    };
    this.textareaRef = React.createRef();
    this.handleChange = this.handleChange.bind(this);
  }

  autoGrow() {
    const el = this.textareaRef.current;
    // offsetParent is null when the element (or an ancestor) is display:none.
    // scrollHeight would be 0 then, collapsing the textarea to 0px.
    if (!el || el.offsetParent === null) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  }

  componentDidMount() {
    const defaultValue = this.props.defaultValue ? this.props.defaultValue : 0;
    const classRow1 = { class: "row1" };
    const classRow2 = { class: "row2" };
    this.setState(defaultValue.length > 33 ? classRow2 : classRow1);
    this.autoGrow();
  }

  componentDidUpdate(prevProps) {
    // Re-measure when the textarea transitions from hidden to visible
    // (e.g. quick-edit opens), since scrollHeight is unavailable while hidden.
    if (prevProps.className !== this.props.className) {
      this.autoGrow();
    }
  }

  handleChange(e) {
    const classRow1 = { class: "row1" };
    const classRow2 = { class: "row2" };
    this.setState(e.target.value.length > 33 ? classRow2 : classRow1);
    this.autoGrow();
  }

  render() {
    const { id, className, name, onInput, defaultValue, key } = this.props;
    return (
      <textarea
        ref={this.textareaRef}
        className={`${className} ${this.state.class}`}
        name={name}
        onInput={onInput}
        defaultValue={defaultValue}
        id={id}
        key={key}
        onChange={(e) => this.handleChange(e)}
      />
    );
  }
}

class ParameterInput extends React.Component {
  /**
   * Function to be sure we are not using wrong values in load input
   * @param {*} e
   */
  handleInputLoad = (e) => {
    let value = e.target.value;

    //replace , for .
    value = value.replace(",", ".");

    //Allow only numbers and .
    value = value.replace(/[^0-9.]/g, "");

    //being sure only exists 1 .
    const parts = value.split(".");
    if (parts.length > 2) {
      value = `${parts[0]}.${parts.slice(1).join("")}`;
    }

    e.target.value = value;

    if (this.props.onInput) {
      this.props.onInput(e);
    }
  };

  render() {
    const {
      id,
      name,
      defaultValue,
      onInput,
      parameter,
      onChange,
      keyParam,
      units,
      intensityMeasure,
      isRiR,
      className = "",
      loadDrop,
    } = this.props;

    if (parameter === FREEFORM) {
      return (
        <TextAreaComp
          className={className}
          name={name}
          onInput={onInput}
          defaultValue={defaultValue}
          id={id}
          key={keyParam}
        />
      );
    } else if ([TIME, REST, DISTANCE, VELOCITY, REPS].includes(parameter)) {
      return (
        <input
          className={className}
          type="text"
          name={name}
          onInput={onInput}
          defaultValue={defaultValue}
          id={id}
          maxLength="6"
          key={keyParam}
        />
      );
    } else if (parameter === LOAD && loadDrop) {
      return (
        <div className={className}>
          <input
            className={`${className} text-left!`}
            type="text"
            name="loadDrop"
            onInput={onInput}
            defaultValue={loadDrop}
          />
          <span
            className="quick-edit-load-unit"
            style={{
              marginLeft: "-16px",
            }}
          >
            % mod.
          </span>
        </div>
      );
    } else if (parameter === LOAD) {
      return (
        <div className={className}>
          <input
            className={className}
            type="text"
            name={name}
            onInput={this.handleInputLoad}
            defaultValue={
              units === "metric"
                ? (defaultValue ?? 0)
                : round(
                    convert(defaultValue ?? 0)
                      .from("kg")
                      .to("lb")
                  )
            }
            id={id}
            key={keyParam}
          />
          <span
            className="quick-edit-load-unit"
            style={{
              marginLeft: "-16px",
            }}
          >
            {defaultValue ? (units === "metric" ? "kg" : "lb") : null}
          </span>
        </div>
      );
    } else if ([RPE, RPEAMRAP].includes(parameter)) {
      return (
        <RpeInput
          id={id}
          className={className}
          name="rpe"
          value={defaultValue}
          isRiR={isRiR}
          placeholder={intensityMeasure}
          emitInvalid={false}
          onChange={onChange}
        />
      );
    }

    return (
      <input
        className={className}
        type="number"
        min={1}
        step="1"
        name={name}
        onInput={onInput}
        defaultValue={defaultValue}
        id={id}
        key={keyParam}
      />
    );
  }
}

ParameterInput.contextType = RillContext;

export default ParameterInput;
